import ProfileProductIcons from './ProfileProductIcons';

export default ProfileProductIcons;
